import { NgModule } from '@angular/core';
import { AutomationAdminComponent } from './automation-admin/automation-admin.component';
import { SharedProviderModule } from '../shared/shared.module';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  imports: [
    SharedProviderModule,
    NgbTypeaheadModule
  ],
  declarations: [AutomationAdminComponent],
  exports: [AutomationAdminComponent]
})
export class AutomationModule { }
